Se agrega el **nuevo módulo de Postventa** junto con mejoras en el sistema de permisos y navegación.

## Nuevo Módulo de Postventa
<Video src="https://assets.elevenestudio.me/changelog-idc/deliveries-module.mp4" />

- Gestión completa de postventa de propiedades
- Control de estados: Pendiente, En progreso, Completado
- Formularios de datos de postventa
- Formularios para actualizar datos de contacto

## Otras Mejoras

- Impresión del reporte FEIC para las personas que proveen fondos

## Correcciones

- Formularios de referidos corregido para mostrar los datos correctamente